import { Collection, ICollection } from 'firebase-firestorm'
import { BaseRepository } from '../Firestore/BaseRepository'
import { GLCodeUPC } from './GLCodeUPC'

export class GLCodeUPCRepository extends BaseRepository<GLCodeUPC> {
  public async findByRestaurant(restaurantId: string) {
    const query = this.getCollection().query()
      .where('restaurantId', '==', restaurantId)
      .get()

    return ( await query ).docs
  }

  protected getCollection(): ICollection<GLCodeUPC> {
    return Collection(GLCodeUPC)
  }

  protected getNewInstance(): GLCodeUPC {
    return new GLCodeUPC()
  }
}
